import PropTypes from 'prop-types'
import { answerPropType } from '@aytm/app/stats/page/question-views/components/lib/prop-types'

// What the shell hands every matrix-family block: the question, the sections of the report params
// the block owns, the params each batch owns, and the handlers the surfaces report back through.
export const MATRIX_BLOCK_PROP_TYPES = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  questionKey: PropTypes.string,
  type: PropTypes.string,
  subType: PropTypes.string,
  variant: PropTypes.string,
  questionType: PropTypes.string,
  format: PropTypes.object,
  components: PropTypes.object,
  answer: answerPropType,
  batches: PropTypes.array,
  degree: PropTypes.number,
  scaleTmpl: PropTypes.string,
  scaleSteps: PropTypes.number,
  scalePow: PropTypes.number,
  maxAnswerPosition: PropTypes.number,
  // the chart mode the question declares in its data
  questionChartMode: PropTypes.string,
  globalChartMode: PropTypes.string,
  clickable: PropTypes.bool,
  defaultSortOrder: PropTypes.string,
  modelDefaults: PropTypes.object,
  link: PropTypes.string,
  isReportXpert: PropTypes.bool,
  params: PropTypes.shape({
    tcv: PropTypes.string,
    cm: PropTypes.string,
    z: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    s: PropTypes.string,
    cb: PropTypes.string,
    wc: PropTypes.string,
    smc: PropTypes.string
  }),
  // bumped by the shell every time it re-reads the params off the model
  paramsRevision: PropTypes.number,
  // the report params every batch owns, keyed by position
  batchParams: PropTypes.object,
  // what a clicked answer label filters by, resolved by the shell
  labelTarget: PropTypes.object,
  handlers: PropTypes.object,
  onReady: PropTypes.func,
  onStateChange: PropTypes.func,
  onWcParamsChange: PropTypes.func,
  onBatchParamsChange: PropTypes.func,
  onBatchWcParamsChange: PropTypes.func,
  onBatchReady: PropTypes.func
}
